import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'react-bootstrap';

import ContactPeopleForm from './people/form';
import ContactCompanyForm from './companies/form';

const ContactTypes = {
  company: 'company',
  person: 'person'
};

export default class QuickNewContactForm extends React.Component {
  static propTypes = {
    additionalFields: PropTypes.node,
    availableDatabaseOptions: PropTypes.arrayOf(PropTypes.array),
    personOrCompany: PropTypes.oneOf(Object.keys(ContactTypes)),
    projectId: PropTypes.number,
    showContactTypeSelector: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  }

  state = {
    contact: null,
    showTypeSelector: true,
    personOrCompany: this.props.personOrCompany || ContactTypes.person
  }

  isCompany = () => this.state.personOrCompany === ContactTypes.company;
  isPerson = () => this.state.personOrCompany === ContactTypes.person;

  toggleTypeSelector = (showTypeSelector) => {
    this.setState({ showTypeSelector });
  }

  renderForm() {
    const {
      additionalFields,
      availableDatabaseOptions,
      projectId,
      onCancel,
      onSave
    } = this.props;

    return (
      <React.Fragment>
        {this.isPerson() &&
          <ContactPeopleForm
            additionalFields={additionalFields}
            availableDatabaseOptions={availableDatabaseOptions}
            projectId={projectId}
            toggleTypeSelector={this.toggleTypeSelector}
            onCancel={onCancel}
            onSave={onSave}
          />
        }
        {this.isCompany() &&
          <ContactCompanyForm
            additionalFields={additionalFields}
            availableDatabaseOptions={availableDatabaseOptions}
            projectId={projectId}
            onCancel={onCancel}
            onSave={onSave}
          />
        }
      </React.Fragment>
    );
  }

  render() {
    if (!this.props.showContactTypeSelector)  return this.renderForm();

    return (
      <React.Fragment>
        <div className="form-horizontal form-group">
          {(this.state.showTypeSelector) &&
            <div className="form-inline">
              <Radio
                checked={this.isPerson()}
                className="ml-0"
                name="person-select"
                onChange={() => this.setState({ personOrCompany: ContactTypes.person })}
              >
                New Person
              </Radio>
              <Radio
                checked={this.isCompany()}
                name="company-select"
                onChange={() => this.setState({ personOrCompany: ContactTypes.company })}
              >
                New Company
              </Radio>
            </div>
          }
        </div>
        {this.renderForm()}
      </React.Fragment>
    );
  }
}
